import { render, staticRenderFns } from "./VariaAfhaal.vue?vue&type=template&id=128277ae&scoped=true&"
import script from "./VariaAfhaal.vue?vue&type=script&lang=js&"
export * from "./VariaAfhaal.vue?vue&type=script&lang=js&"
import style0 from "./VariaAfhaal.vue?vue&type=style&index=0&id=128277ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128277ae",
  null
  
)

export default component.exports